import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            海量资源 · 随心观看
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            涵盖电影、电视剧、综艺、动漫四大分类，满足您所有的追剧需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-2xl p-6 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <span className="mt-4 text-sm text-primary-500 font-medium flex items-center gap-1 whitespace-nowrap">
                立即浏览 <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}